/* THIS FILE IS AUTOGENERATED. DO NOT MODIFY */
/* eslint-disable */
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };


/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDateTime: string | Date;
  GraphQLDate: string | Date;
  Html: string;
  PersonAge: number;
  PhoneNumber: string;
  EmailAddress: string;
  Postcode: string;
  Town: string;
  Language: string;
};

export enum TestStatus {
  Passed = "Passed",
  Failed = "Failed",
  Cancelled = "Cancelled",
  Upcoming = "Upcoming"
}

export enum TestType {
  Theory = "Theory",
  Practical = "Practical",
  DIT1 = "DIT1",
  DIT2 = "DIT2",
  DIT3 = "DIT3"
}

export enum EventStatus {
  Upcoming = 'UPCOMING',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED'
}

export enum LessonType {
  PostTestLesson = 'PostTestLesson',
  PreTestLesson = 'PreTestLesson',
  MotabilityLesson = 'MotabilityLesson',
  LearnerLesson = 'LearnerLesson',
  DitLesson = 'DITLesson'
}


export enum LearnerType {
  Learner = 'Learner',
  Dit = 'DIT'
}

export enum Brand {
  Bsm = 'BSM',
  Aad = 'AAD'
}

export enum LearnerStatus {
  Approved = 'APPROVED',
  Unapproved = 'UNAPPROVED',
  Rejected = 'REJECTED'
}

export enum NotificationType {
  ApproveLearner = 'APPROVE_LEARNER',
  ServiceMessage = 'SERVICE_MESSAGE',
  OpenCap = 'OPEN_CAP'
}

export enum EventType {
  Unavailable = 'UNAVAILABLE',
  PaidLesson = 'PAID_LESSON',
  UnpaidLesson = 'UNPAID_LESSON',
  NewLesson = 'NEW_LESSON',
  Travel = 'TRAVEL'
}

export enum EventRepeat {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly'
}

export enum PostType {
  News = 'NEWS',
  Tech = 'TECH'
}

export enum AreaType {
  Learner = 'LEARNER',
  Dit = 'DIT',
  Motability = 'MOTABILITY'
}

export enum TransmissionType {
  Manual = 'MANUAL',
  Automatic = 'AUTOMATIC'
}

export enum FuelType {
  Petrol = 'PETROL',
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC'
}


export enum Salutation {
  Dr = "Dr",
  Master = "Master",
  Mr = "Mr",
  Mrs = "Mrs",
  Ms = "Ms",
  Mx = "Mx",
  Miss = "Miss"
}

export enum DiscountType {
  NewLearner = 'NewLearner',
  ExistingLearner = 'ExistingLearner'
}

export type LoginCredentials = {
  id: Scalars['ID'];
  password: Scalars['String'];
};

export type SignUpCredentials = {
  adiNumber: Scalars['ID'];
  mobileNumber: Scalars['String'];
};

export type AuthenticationCredentials = {
  userId: Scalars['ID'];
  authenticationCode: Scalars['String'];
};

export type PasswordReset = {
  userId: Scalars['ID'];
  password: Scalars['String'];
};

export type RejectLearnerInput = {
  id: Scalars['ID'];
  rejectionReason: Scalars['String'];
};

export type DeleteLessonEventInput = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};

export type DeleteUnavailableEventInput = {
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  series?: Maybe<Scalars['Boolean']>;
};

/**
 * Add more fields to this as and when you want them to be editable.
 * Make sure they're nullable to allow partial updates
 */
export type UpdateEventInput = {
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
};

export type CreateLearnerInput = {
  salutation: Salutation;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  town: Scalars['Town'];
  postcode: Scalars['String'];
  phoneNumber: Scalars['String'];
  emailAddress: Scalars['String'];
  dateOfBirth: Scalars['AWSDateTime'];
  lessonType: LessonType;
  type: LearnerType;
  rateInPence: Scalars['Int'];
};

export type UpsertTestInput = {
  learnerId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  date: Scalars['AWSDateTime'];
  status: TestStatus;
  type: TestType;
};

export type DeleteTestInput = {
  id: Scalars['ID'];
};

export type CreateEventInput = {
  type: EventType;
  repeat?: Maybe<EventRepeat>;
  repeatStartDate?: Maybe<Scalars['AWSDateTime']>;
  repeatEndDate?: Maybe<Scalars['AWSDateTime']>;
  learnerId?: Maybe<Scalars['ID']>;
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  notes?: Maybe<Scalars['String']>;
};

export type CreateArea = {
  id: Scalars['ID'];
};

export type PostsInput = {
  limit?: Maybe<Scalars['Int']>;
  type: PostType;
};

export type EventsInput = {
  types?: Maybe<Array<Maybe<EventType>>>;
  startDate?: Maybe<Scalars['AWSDateTime']>;
  endDate?: Maybe<Scalars['AWSDateTime']>;
};

export type UpdatedWorkingHoursRange = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type UpdatedWorkingHours = {
  monday?: Maybe<UpdatedWorkingHoursRange>;
  tuesday?: Maybe<UpdatedWorkingHoursRange>;
  wednesday?: Maybe<UpdatedWorkingHoursRange>;
  thursday?: Maybe<UpdatedWorkingHoursRange>;
  friday?: Maybe<UpdatedWorkingHoursRange>;
  saturday?: Maybe<UpdatedWorkingHoursRange>;
  sunday?: Maybe<UpdatedWorkingHoursRange>;
};

export type UpdatedLearnerCapacity = {
  lessonType: LessonType;
  currentCapacity: Scalars['Int'];
  maximumCapacity: Scalars['Int'];
};

export type UpdatedPreferences = {
  travelTime?: Maybe<Scalars['Int']>;
  lessonTypes?: Maybe<Array<LessonType>>;
  workingHours?: Maybe<UpdatedWorkingHours>;
  learnerCapacity?: Maybe<Array<UpdatedLearnerCapacity>>;
};

export type AreasInput = {
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<AreaType>;
};

export type UpdatedMileage = {
  id: Scalars['ID'];
  mileage: Scalars['Int'];
};

export type UpdatedDetails = {
  mileage?: Maybe<Array<UpdatedMileage>>;
};

export type UpdateAreaInput = {
  id: Scalars['ID'];
  sectors?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rateInPence?: Maybe<Scalars['Int']>;
  postTestRateInPence?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type SendMessageInput = {
  message: Scalars['String'];
};

export type Login = {
  __typename?: 'Login';
  token: Scalars['String'];
};

export type SignUp = {
  __typename?: 'SignUp';
  userId: Scalars['String'];
};

export type Authenticate = {
  __typename?: 'Authenticate';
  token: Scalars['String'];
};

export type Password = {
  __typename?: 'Password';
  success: Scalars['Boolean'];
};

export type Name = {
  __typename?: 'Name';
  title?: Maybe<Salutation>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  fullName: Scalars['String'];
};

export type WorkingHoursRange = {
  __typename?: 'WorkingHoursRange';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  monday?: Maybe<WorkingHoursRange>;
  tuesday?: Maybe<WorkingHoursRange>;
  wednesday?: Maybe<WorkingHoursRange>;
  thursday?: Maybe<WorkingHoursRange>;
  friday?: Maybe<WorkingHoursRange>;
  saturday?: Maybe<WorkingHoursRange>;
  sunday?: Maybe<WorkingHoursRange>;
};

export type TestCentre = {
  __typename?: 'TestCentre';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID'];
  registration: Scalars['String'];
  make: Scalars['String'];
  model: Scalars['String'];
  transmissionType: TransmissionType;
  fuelType: FuelType;
  mileage: Scalars['Int'];
  mileageUpdated: Scalars['AWSDateTime'];
  leaseStartDate: Scalars['AWSDateTime'];
  additionalDrivers?: Maybe<Array<Name>>;
};

export type Qualification = {
  __typename?: 'Qualification';
  id: Scalars['ID'];
  title: Scalars['String'];
  reference: Scalars['String'];
  expiry: Scalars['AWSDateTime'];
};

export type Franchise = {
  __typename?: 'Franchise';
  id: Scalars['ID'];
  title: Scalars['String'];
  startDate: Scalars['AWSDateTime'];
  endDate: Scalars['AWSDateTime'];
  feeInPence: Scalars['Int'];
};

export type LoyaltyProgramme = {
  __typename?: 'LoyaltyProgramme';
  id: Scalars['ID'];
  title: Scalars['String'];
  startDate: Scalars['AWSDateTime'];
  discountInPence: Scalars['Int'];
};

export type Instructor = {
  __typename?: 'Instructor';
  id: Scalars['ID'];
  name: Name;
  dateOfBirth: Scalars['AWSDateTime'];
  address: Address;
  emailAddress: Scalars['EmailAddress'];
  mobileNumber: Scalars['PhoneNumber'];
  landlineNumber?: Maybe<Scalars['PhoneNumber']>;
  vehicles: Array<Vehicle>;
  qualifications?: Maybe<Array<Qualification>>;
  events: Array<Event>;
  learners: Array<Learner>;
  notifications: Array<Notification>;
  todaysEvents: Array<Event>;
  learnerCapacity: Array<LearnerCapacity>;
  todaysIncome: Scalars['Int'];
  areas: Array<Area>;
  brand: Brand;
  travelTime: Scalars['Int'];
  lessonTypes: Array<LessonType>;
  workingHours: WorkingHours;
  franchise: Franchise;
};


export type InstructorEventsArgs = {
  input?: Maybe<EventsInput>;
};


export type InstructorTodaysEventsArgs = {
  input?: Maybe<EventsInput>;
};


export type InstructorAreasArgs = {
  input: AreasInput;
};

export type Learner = {
  __typename?: 'Learner';
  id: Scalars['ID'];
  created: Scalars['AWSDateTime'];
  name: Name;
  status: PersonStatus;
  allocationStatus?: Maybe<LearnerAllocationStatus>;
  age: Scalars['PersonAge'];
  mobileNumber?: Maybe<Scalars['PhoneNumber']>;
  landlineNumber?: Maybe<Scalars['PhoneNumber']>;
  address: Address;
  tests: Array<Test>;
  lessons: Array<Event>;
  lastLesson?: Maybe<Scalars['String']>;
  lessonBalance?: Maybe<Scalars['Int']>;
  lessonType?: Maybe<LessonType>;
  rateInPence?: Maybe<Scalars['Int']>;
};
export enum LearnerAllocationStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum PersonStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deleted = 'Deleted'
}


export type LearnerEventsArgs = {
  input?: Maybe<EventsInput>;
};

export type Test = {
  __typename?: 'Test';
  id: Scalars['ID'];
  date: Scalars['AWSDateTime'];
  status: TestStatus;
  editable: Scalars['Boolean'];
  type: TestType;
};

export type LearnerCapacity = {
  __typename?: 'LearnerCapacity';
  lessonType: LessonType;
  currentCapacity: Scalars['Int'];
  maximumCapacity: Scalars['Int'];
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  type: NotificationType;
  count: Scalars['Int'];
};

export type Post = {
  __typename?: 'Post';
  id: Scalars['ID'];
  title: Scalars['String'];
  date: Scalars['AWSDateTime'];
  content: Scalars['Html'];
  author: Name;
  read: Scalars['Boolean'];
  brand: Brand;
};

export type InstructorPreferences = {

};

export type AddressLookupResult = {
  __typename?: 'AddressLookupResult';
  id: Scalars['ID'];
  description: Scalars['String'];
};

export type AreaLookupResult = {
  __typename?: 'AreaLookupResult';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  town: Scalars['Town'];
  county?: Maybe<Scalars['String']>;
  postcode: Scalars['Postcode'];
};

export type Lesson = {
  id: Scalars['ID'];
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  learner?: Maybe<Learner>;
  status: EventStatus;
  pickupPostcode: Scalars['Postcode'];
  notes?: Maybe<Scalars['String']>;
  type: EventType;
};

export type UnpaidLessonEvent = Lesson & {
  __typename?: 'UnpaidLessonEvent';
  id: Scalars['ID'];
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  learner?: Maybe<Learner>;
  status: EventStatus;
  pickupPostcode: Scalars['Postcode'];
  notes?: Maybe<Scalars['String']>;
  type: EventType;
};

export type PaidLessonEvent = Lesson & {
  __typename?: 'PaidLessonEvent';
  id: Scalars['ID'];
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  learner?: Maybe<Learner>;
  status: EventStatus;
  pickupPostcode: Scalars['Postcode'];
  notes?: Maybe<Scalars['String']>;
  type: EventType;
};

export type NewLessonEvent = Lesson & {
  __typename?: 'NewLessonEvent';
  id: Scalars['ID'];
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  learner?: Maybe<Learner>;
  status: EventStatus;
  pickupPostcode: Scalars['Postcode'];
  notes?: Maybe<Scalars['String']>;
  type: EventType;
};

export type UnavailableEvent = {
  __typename?: 'UnavailableEvent';
  id: Scalars['ID'];
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  status: EventStatus;
  type: EventType;
  notes?: Maybe<Scalars['String']>;
  repeat?: Maybe<EventRepeat>;
};

export type TravelEvent = {
  __typename?: 'TravelEvent';
  id: Scalars['ID'];
  startDateTime: Scalars['AWSDateTime'];
  endDateTime: Scalars['AWSDateTime'];
  status: EventStatus;
  type: EventType;
};

export type Event = PaidLessonEvent | UnpaidLessonEvent | NewLessonEvent | UnavailableEvent | TravelEvent;

export type Discount = {
  __typename?: 'Discount';
  id: Scalars['ID'];
  hours: Scalars['String'];
  amountInPence: Scalars['Int'];
  type: DiscountType;
  description?: Maybe<Scalars['String']>;
};

export type Area = {
  __typename?: 'Area';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: AreaType;
  areaCode: Scalars['String'];
  districts: Array<Maybe<District>>;
  numberOfDistricts: Scalars['Int'];
  numberOfCoveredDistricts: Scalars['Int'];
  rateInPence: Scalars['Int'];
  postTestRateInPence?: Maybe<Scalars['Int']>;
  ratesUpdated: Scalars['AWSDateTime'];
  numberOfDiscountsAvailable?: Maybe<Scalars['Int']>;
  numberOfDiscountsApplied?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Discount>>;
};

export type AreaInput = {
  __typename?: 'Area';
  id: Scalars['ID'];
  name?: Scalars['String'];
  type?: AreaType;
  areaCode?: Scalars['String'];
  districts?: Array<District>;
  numberOfDistricts?: Scalars['Int'];
  numberOfCoveredDistricts?: Scalars['Int'];
  rateInPence?: Scalars['Int'];
  postTestRateInPence?: Maybe<Scalars['Int']>;
  ratesUpdated?: Scalars['AWSDateTime'];
  numberOfDiscountsAvailable?: Maybe<Scalars['Int']>;
  numberOfDiscountsApplied?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Array<Discount>>;
};

export type District = {
  __typename?: 'District';
  id: Scalars['ID'];
  postcode?: Maybe<Scalars['String']>;
  sectors: Array<Sector>;
};

export type Sector = {
  __typename?: 'Sector';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  me: Instructor;
  learner: Learner;
  area: Area;
  posts: Array<Post>;
  addressLookup: Array<AddressLookupResult>;
  areaLookup: Array<AreaLookupResult>;
  fullAddress: Address;
  emailAddressExistsCheck: Scalars['Boolean'];
  event: Event;
  testCentres: Array<TestCentre>;
};


export type QueryLearnerArgs = {
  id: Scalars['ID'];
};


export type QueryAreaArgs = {
  id: Scalars['ID'];
};


export type QueryPostsArgs = {
  input: PostsInput;
};


export type QueryAddressLookupArgs = {
  postcode: Scalars['String'];
};


export type QueryAreaLookupArgs = {
  postcode: Scalars['String'];
};


export type QueryFullAddressArgs = {
  id: Scalars['String'];
};


export type QueryEmailAddressExistsCheckArgs = {
  emailAddress: Scalars['String'];
};


export type Message = {
  __typename?: 'Message';
  id: Scalars['ID'];
  body: Scalars['String'];
  created: Date;
  from: Scalars['Int'];
};

export type CreateMessageMutationInput = {
  instructorId: Scalars['ID'];
  body: Scalars['String'];
};

export type MessageInput = {
  offset: Scalars['Int'];
  total: Scalars['Int'];
};


export type QueryEventArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticate: Authenticate;
  createLearner: Learner;
  deleteTest: Test;
  login: Login;
  password: Password;
  rejectLearner: Learner;
  signUp: SignUp;
  updateTest: Test;
  updateEvent: Event;
  createEvent: Array<Event>;
  deleteLessonEvent: Event;
  deleteUnavailableEvent: Array<Event>;
  updatePreferences: Instructor;
  updateInstructorDetails: Instructor;
  createArea: Area;
  updateArea: Area;
  deleteArea: Area;
  sendMessage: Message;
};


export type MutationAuthenticateArgs = {
  input: AuthenticationCredentials;
};


export type MutationCreateLearnerArgs = {
  input: CreateLearnerInput;
};


export type MutationDeleteTestArgs = {
  input: DeleteTestInput;
};


export type MutationLoginArgs = {
  input: LoginCredentials;
};


export type MutationPasswordArgs = {
  input: PasswordReset;
};


export type MutationRejectLearnerArgs = {
  input: RejectLearnerInput;
};


export type MutationSignUpArgs = {
  input: SignUpCredentials;
};


export type MutationUpsertTestArgs = {
  input: UpsertTestInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationDeleteLessonEventArgs = {
  input: DeleteLessonEventInput;
};


export type MutationDeleteUnavailableEventArgs = {
  input: DeleteUnavailableEventInput;
};


export type MutationUpdatePreferencesArgs = {
  input: UpdatedPreferences;
};


export type MutationUpdateInstructorDetailsArgs = {
  input: UpdatedDetails;
};


export type MutationCreateAreaArgs = {
  input: CreateArea;
};


export type MutationUpdateAreaArgs = {
  input: UpdateAreaInput;
};


export type MutationDeleteAreaArgs = {
  ids: Array<string>
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};